<template>
    <div class="viewBox">
        <div class="editor" >
            <div class="left">
               <button @click="changePhoto(index)" :class="photoActiveIndex==index ? 'photoActive':''" v-for="(item,index) in photoList" :key="index">
                    <img :src="`https://respool.isheji.com/isheji/static/qiye/image/lab/similaritySearch/${item}`" >
               </button>
            </div>
            <div class="right">
                <img :src="`https://respool.isheji.com/isheji/static/qiye/image/lab/similaritySearch/${photoList[photoActiveIndex]}`" alt="">
            </div>
        </div>
        <div class="pool" v-if="poolList.length>0">
            <justified-infinite-grid ref="grid"
            class="container"
            :gap="16"
            :columnRange="[3,4]"
            >
            <img class="waterfallImg" :src="imgitem.src" v-for="(imgitem,imgindex) in poolList[photoActiveIndex].similaritySearch" :key="imgindex"  alt="">
            </justified-infinite-grid>
        </div>
    </div>
</template>
<script>
import { JustifiedInfiniteGrid } from "@egjs/vue-infinitegrid";
import Axios from "axios";

export default {
    data(){
        return{
            photoList:[
                '1.jpg',
                '2.jpg',
                '3.jpg',
                '4.jpg',
            ],
            photoActiveIndex:1,
            poolList:[],
          
        }
    },
    components: {
        JustifiedInfiniteGrid
    },
    methods:{
        changePhoto(index){
            this.photoActiveIndex = index;
        },
        
        
    },
    mounted() {
       Axios.get('json/similaritySearch.json').then((res)=>{
            this.poolList = res.data;
             this.$nextTick(() => {
                
               this.photoActiveIndex = 0;
                this.$refs.grid.updateItems();
             })
       })
    },
}
</script>
<style lang="scss" scoped>
    .editor{
       
        width:100%;
        border-radius: 8px;
        overflow: hidden;
        background-color: #171a27;
        position: relative;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-pack: normal;
        justify-content: normal;
        -ms-flex-align: normal;
        align-items: normal;
        -ms-flex-direction: row;
        flex-direction: row;
        -ms-flex-wrap: nowrap;
        flex-wrap: nowrap;
        margin-bottom: 16px;
        .left{
            width: 244px;
            position: relative;
            padding: 50px;
            display: -ms-flexbox;
            display: flex;
            -ms-flex-pack: start;
            justify-content: flex-start;
            -ms-flex-align: center;
            align-items: center;
            -ms-flex-direction: column;
            flex-direction: column;
            -ms-flex-wrap: nowrap;
            flex-wrap: nowrap;
            button{
                width: 102px;
                height: 102px;
                border: none;
                padding: 0;
                overflow: hidden;
                position: relative;
                margin-top: 18px;
                &:first-child{
                    margin-top: 0;
                }
                cursor: pointer;
                img{
                    width: inherit;
                    height: inherit;
                    position: absolute;
                    top: 0;
                    left: 0;
                    -o-object-fit: cover;
                    object-fit: cover;
                    -o-object-position: center;
                    object-position: center;
                    -webkit-user-select: none;
                    -moz-user-select: none;
                    -ms-user-select: none;
                    user-select: none;
                }
            }
            .photoActive{
                &::after{
                    content: '';
                    display: block;
                    position: absolute;
                    z-index: 2;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;
                    border: 4px solid transparent;
                    -webkit-transition: border-color ease-in-out 280ms;
                    -o-transition: border-color ease-in-out 280ms;
                    transition: border-color ease-in-out 280ms;
                    border-color: #5986ff;
                }
            }
        }
        .right{
            -ms-flex: 1 1;
            flex: 1 1;
            padding: 50px;
            background-color: #202537;
            position: relative;
            display: -ms-flexbox;
            display: flex;
            -ms-flex-pack: center;
            justify-content: center;
            -ms-flex-align: center;
            align-items: center;
            -ms-flex-direction: row;
            flex-direction: row;
            -ms-flex-wrap: nowrap;
            flex-wrap: nowrap;
            img{
                position: relative;
                width: 100%;
                z-index: 1;
                min-height: 100px;
                overflow: hidden;
            }
        }
    }
  
</style>